<template>
  <span
    class="bg-ontick-blue-900 rounded-sm py-0.5 px-2 text-[10px] font-semibold text-white"
  >
    {{ symbol }}
  </span>
</template>

<script>
export default {
  props: {
    symbol: {
      type: String,
      required: true,
    },
  },
};
</script>

<style></style>
